import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "О компании", href: "#about" },
    { label: "Продукция", href: "#mic" },
    { label: "Матрица ТО", href: "#matrix" },
    { label: "Масла Shell", href: "#shell" },
    { label: "Логистика", href: "#logistics" },
    { label: "Контакты", href: "#contact" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0A0F1A] shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between h-[72px]">

        {/* Logo — image placeholder, replace src with real logo */}
        <a href="#" className="flex items-center cursor-pointer flex-shrink-0">
          <img
            src="/logo.png"
            alt="YAXIN LIANPEI — автозапчасти из КНР"
            className="h-10 w-auto object-contain"
            onError={(e) => {
              const target = e.currentTarget;
              target.style.display = "none";
              const fallback = target.nextElementSibling as HTMLElement | null;
              if (fallback) fallback.style.display = "flex";
            }}
          />
          {/* Fallback shown only if logo.png not found */}
          <div
            className="items-center justify-center bg-[#C9A84C] rounded-sm h-10 px-3"
            style={{ display: "none" }}
          >
            <span className="text-[#0A0F1A] font-black text-lg tracking-widest" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
              YAXIN
            </span>
          </div>
        </a>

        {/* Desktop Nav — centered with generous spacing */}
        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-gray-300 hover:text-[#C9A84C] text-sm font-medium tracking-widest uppercase transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Right side — Email only */}
        <div className="hidden lg:flex items-center gap-4 border-l border-[#C9A84C]/20 pl-6">
          <a
            href="mailto:eagle_parts@vk.com"
            className="flex items-center gap-2 text-gray-400 hover:text-[#C9A84C] transition-colors duration-200 group cursor-pointer whitespace-nowrap"
            title="Рекомендуем email — быстрее из-за разницы часовых поясов"
          >
            <div className="w-7 h-7 flex items-center justify-center border border-[#C9A84C]/30 group-hover:border-[#C9A84C] rounded-sm transition-colors flex-shrink-0">
              <i className="ri-mail-line text-[#C9A84C] text-xs"></i>
            </div>
            <div className="flex flex-col leading-tight">
              <span className="text-xs font-semibold tracking-wide">eagle_parts@vk.com</span>
              <span className="text-[9px] text-[#C9A84C]/50 tracking-wide">рекомендуем · учитывайте часовые пояса</span>
            </div>
          </a>

          {/* CTA */}
          <a
            href="#contact"
            className="flex items-center gap-2 bg-[#C9A84C] hover:bg-[#b8943d] text-[#0A0F1A] font-bold text-sm px-5 py-2.5 rounded-sm tracking-wide uppercase transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-list-3-line text-base"></i>
            B2B Прайс-лист
          </a>
        </div>

        {/* CTA visible on md but not lg (no contacts shown) */}
        <a
          href="#contact"
          className="hidden md:flex lg:hidden items-center gap-2 bg-[#C9A84C] hover:bg-[#b8943d] text-[#0A0F1A] font-bold text-sm px-5 py-2.5 rounded-sm tracking-wide uppercase transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-file-list-3-line text-base"></i>
          B2B Прайс-лист
        </a>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0A0F1A] border-t border-[#C9A84C]/20 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-gray-300 hover:text-[#C9A84C] text-sm font-medium tracking-wide uppercase transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="bg-[#C9A84C] text-[#0A0F1A] font-bold text-sm px-5 py-3 rounded-sm tracking-wide uppercase text-center cursor-pointer"
          >
            Запросить B2B прайс-лист
          </a>
          {/* Mobile quick contacts */}
          <div className="border-t border-[#C9A84C]/15 pt-4 flex flex-col gap-3">
            <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.25em] uppercase">Прямой контакт · MAX</div>
            <a href="tel:+79099337759" className="flex items-center gap-3 text-gray-300 hover:text-[#C9A84C] transition-colors cursor-pointer">
              <span className="text-[#C9A84C] text-[9px] font-black tracking-widest uppercase border border-[#C9A84C]/40 px-1 py-0.5 rounded-sm flex-shrink-0">MAX</span>
              <i className="ri-telegram-line text-[#C9A84C] text-base flex-shrink-0"></i>
              <span className="text-sm font-medium">+7 (909) 933-77-59</span>
            </a>
            <a href="mailto:eagle_parts@vk.com" className="flex items-center gap-3 text-gray-300 hover:text-[#C9A84C] transition-colors cursor-pointer">
              <i className="ri-mail-line text-[#C9A84C] text-base flex-shrink-0"></i>
              <div className="flex flex-col">
                <span className="text-sm font-medium">eagle_parts@vk.com</span>
                <span className="text-[10px] text-[#C9A84C]/60">Рекомендуем — учитывайте разницу часовых поясов</span>
              </div>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
